(() => {
  if (window.zenifyProductPoliciesReady) return;
  window.zenifyProductPoliciesReady = true;
  let opener;
  let scrollPosition;
  let bodyStyle;
  let activeDialog;
  const policyKey = (anchor) => {
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return null;
    return url.pathname.match(/\/policies\/(privacy-policy|shipping-policy|refund-policy)\/?$/)?.[1] || null;
  };
  const restore = () => {
    if (!activeDialog) return;
    document.body.style.cssText = bodyStyle;
    const htmlStyle = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(scrollPosition.x, scrollPosition.y);
    document.documentElement.style.scrollBehavior = htmlStyle;
    opener?.focus({ preventScroll: true });
    activeDialog = null;
  };
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-zn-policy-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    const anchor = event.target.closest('a[href]');
    if (!anchor || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const key = policyKey(anchor);
    const dialog = document.querySelector('[data-zn-policies]');
    const template = key && document.querySelector(`template[data-zn-policy="${key}"]`);
    if (!dialog || !template || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const content = dialog.querySelector('[data-zn-policy-body]');
    content.replaceChildren(template.content.cloneNode(true));
    content.querySelectorAll('p').forEach((paragraph) => {
      if (!paragraph.textContent.trim() && !paragraph.querySelector('img,video,iframe')) paragraph.hidden = true;
    });
    dialog.querySelector('h2').textContent = template.dataset.policyTitle;
    content.scrollTop = 0;
    if (dialog.open) return;
    opener = anchor;
    scrollPosition = { x: window.scrollX, y: window.scrollY };
    bodyStyle = document.body.style.cssText;
    dialog.showModal();
    activeDialog = dialog;
    Object.assign(document.body.style, { position: 'fixed', top: `-${scrollPosition.y}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
    dialog.querySelector('#ZenifyPolicyTitle').focus({ preventScroll: true });
    content.scrollTop = 0;
    dialog.addEventListener('close', restore, { once: true });
  });
  let backdropPress = false;
  document.addEventListener('pointerdown', (event) => {
    backdropPress = Boolean(activeDialog && event.target === activeDialog);
  });
  document.addEventListener('click', (event) => {
    if (activeDialog && backdropPress && event.target === activeDialog) activeDialog.close();
    backdropPress = false;
  });
  document.addEventListener('shopify:section:unload', () => {
    if (activeDialog) {
      activeDialog.close();
      restore();
    }
  });
})();

